// Spotify PKCE OAuth callback — intercambia el code por access_token (puro cliente)
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

const REDIRECT = `${window.location.origin}/music/spotify-callback`;

const SpotifyCallback = () => {
  const [status, setStatus] = useState('working');
  const [msg, setMsg] = useState('Procesando autorización…');
  const navigate = useNavigate();

  useEffect(() => {
    const exchange = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const error = params.get('error');
      if (error) { setStatus('error'); setMsg(`Spotify: ${error}`); return; }
      if (!code) { setStatus('error'); setMsg('No se recibió código de autorización'); return; }

      const verifier = sessionStorage.getItem('spotify_pkce_verifier');
      const clientId = sessionStorage.getItem('spotify_pkce_client_id');
      if (!verifier || !clientId) { setStatus('error'); setMsg('Sesión PKCE perdida. Intenta de nuevo.'); return; }

      try {
        const body = new URLSearchParams({
          client_id: clientId,
          grant_type: 'authorization_code',
          code, redirect_uri: REDIRECT, code_verifier: verifier,
        });
        const res = await fetch('https://accounts.spotify.com/api/token', {
          method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body
        });
        const data = await res.json();
        if (!data.access_token) {
          setStatus('error'); setMsg(data.error_description || 'No se obtuvo token');
          return;
        }
        const tok = {
          ...data,
          client_id: clientId,
          expires_at: Date.now() + (data.expires_in || 3600) * 1000,
        };
        localStorage.setItem('spotify_token', JSON.stringify(tok));
        sessionStorage.removeItem('spotify_pkce_verifier');
        setStatus('ok'); setMsg('¡Spotify conectado!');
        setTimeout(() => navigate('/dashboard?section=music&tab=connect', { replace: true }), 1200);
      } catch (e) {
        setStatus('error'); setMsg('Error al intercambiar el código');
      }
    };
    exchange();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="bg-[#0d1117] border border-white/10 rounded-2xl p-8 max-w-sm text-center">
        {status === 'working' && <Loader2 className="w-10 h-10 text-[#1DB954] animate-spin mx-auto mb-4" />}
        {status === 'ok' && <CheckCircle2 className="w-10 h-10 text-green-500 mx-auto mb-4" />}
        {status === 'error' && <XCircle className="w-10 h-10 text-red-500 mx-auto mb-4" />}
        <h1 className="text-white font-semibold text-lg mb-2">Spotify</h1>
        <p className="text-gray-400 text-sm">{msg}</p>
        {status === 'error' && (
          <button onClick={() => navigate('/dashboard?section=music&tab=connect')}
            className="mt-5 px-4 py-2 bg-white/5 hover:bg-white/10 text-gray-300 rounded-lg text-sm">
            Volver
          </button>
        )}
      </div>
    </div>
  );
};

export default SpotifyCallback;
